import styled from '@emotion/styled';
import { ReactNode } from 'react';
import { CloseSVG } from 'rwl-ui';

const CloseButtonContainer = styled.div`
    width: 40px;
    height: 40px;

    align-self: center;

    border-radius: 20px;

    display: flex;
    justify-content: center;
    align-items: center;

    margin: var(--rwl-spacing-md);

    cursor: pointer;

    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.4);
`;

export const CloseButton = ({
    onClick,
    children = <CloseSVG />,
}: {
    onClick: () => void;
    children: ReactNode;
}) => {
    return (
        <CloseButtonContainer onClick={onClick}>
            {children}
        </CloseButtonContainer>
    );
};
